import { BrowserView, MobileView } from 'react-device-detect';
import React, { useEffect, useRef, useState } from 'react';
import LoginHeader from '../../Header/LoginHeader';
import UserHeader from '../../Header/UserHeader';
import LocationBar from '../../LocationBar/LocationBar';
import styles from './HotpleContents.module.css';
import HotpleItem from './HotpleItem/HotpleItem';
import AdminHeader from '../../Header/AdminHeader';
import { forceCheck } from 'react-lazyload';


const HotpleContents = ({ activeMenu, setActiveMenu, setUserModalPage, setAuthModalPage, setInfoModalPage, setTutorialModalPage, notices, account, myHotples, rangeHotples, mapHotples, adminHotples, updateHotpleInfo, mapLocation, setIsSearchMode, selectedHotple, setSelectedHotple, selectedOption, setSelectedOption, fcmToken, setModalProps, hotThreshold, mobileHotpleRefs, devicePosition, setAnlysisPageHotple}) => {
	const hotpleRefs = useRef({});
	const [currentPage, setCurrentPage] = useState(0);
	const mobileContainerRef = useRef(null);

	// 한 페이지당 100개씩 보여줌
	const totalPages = Math.ceil(mapHotples.hotples.length / 100);
	const currentHotplePage = activeMenu === 'my' || activeMenu === 'admin' ? mapHotples.hotples.slice(currentPage * 100, currentPage * 100 + 100) : mapHotples.hotples.slice(0, 100);

	// 선택된 hotple이 있다면 해당 아이템이 포함된 페이지로 이동
	useEffect(() => {
		if (selectedHotple && (activeMenu == 'my' || activeMenu === 'admin')) {
			const index = mapHotples.hotples.findIndex(h => h.hotple_id === selectedHotple.hotple_id);
			if (index !== -1) {
				const newPage = Math.floor(index / 100);
				if (newPage !== currentPage) {
					setCurrentPage(newPage);
				}
			}
		}
	}, [selectedHotple, currentPage]);

	useEffect(() => {
		if (mobileContainerRef.current) {
		  mobileContainerRef.current.scrollIntoView({ behavior: 'instant', block: 'start' });
		}
	}, [currentPage]);

	useEffect(() => {
		setCurrentPage(0);
	}, [selectedOption]);

	const whenTopButtonClicked = () => {
		if (mobileContainerRef.current) {
			mobileContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		  }
	};

	const refreshAdminHotple = () => {
		updateHotpleInfo("refreshAdminHotples")
	};

	const toggleSubCategoryOption = (category) => {
		if(selectedOption.sub_category == 'all' && category == 'all')
			return;
		
		if(selectedOption.sub_category == category)
			setSelectedOption((prev)=>({...prev, sub_category:'all'}));
		else
			setSelectedOption((prev)=>({...prev, sub_category:category}));
	}

	useEffect(() => {
		if (selectedHotple && hotpleRefs.current[selectedHotple.hotple_id]) {
			hotpleRefs.current[selectedHotple.hotple_id].scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
		forceCheck();
	}, [selectedHotple]);

	useEffect(() => {
		forceCheck(); 
	}, [mapHotples]);

	const getFilteredMapHotples = (hotples) => {
		  let category_kor;
		  switch(selectedOption.category) {
			case "cafe":
				category_kor='카페디저트'
				break;
			case "alcohol":
				category_kor='주점'
				break;
			case "restaurant":
				category_kor='음식점'
				break;
			case "popupStore":
				category_kor='팝업스토어'
				break;
			case "cultural":
				category_kor='문화예술'
				break;
			case "activity":
				category_kor='오락액티비티'
				break;
			case "rest":
				category_kor='휴식힐링'
				break;
			case "accommodation":
				category_kor='숙소'
				break;
			default:
				category_kor='추천'
		  }
	
		  let filteredHotples = hotples;
	
		  if(selectedOption.region!='전국' && selectedOption.region!='위치'){
			filteredHotples = {hotples: filteredHotples.hotples.filter(hotple => hotple.region == selectedOption.region)}
		  }
	
		  if(selectedOption.category!='recommend' && !selectedOption.category.startsWith('@'))
			filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => hotple.main_category == category_kor)}
	
		  if(activeMenu=='my' || activeMenu=='admin'){
			switch(selectedOption.filter){
			  case null:
			  case 'all':
				break;
			  case 'need_verify':
				filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => hotple.need_verify == true)}
				break;
			  case 'my_pick':
				if(activeMenu=='admin')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => hotple.taggedBy == null)}
				break;
			  case 'has_period':
				filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => hotple.has_period == true)}
				break;
			  case 'edit_request':
				if(activeMenu=='my')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples: filteredHotples.hotples.filter(hotple => hotple.verify_results && hotple.verify_results.length>0)};
				break;
			  case 'err_image':
				if(activeMenu=='my')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => !hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0)}
				break;
			  case 'err_info':
				if(activeMenu=='my')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => !hotple.name || !hotple.caption || !hotple.main_category || !hotple.sub_category1 || !hotple.sub_category2 || !hotple.tags || !hotple.place_name || !hotple.address || !hotple.region || !hotple.latitude || !hotple.longitude|| !hotple.media_url)}
				break;
			  case 'err_place':
				if(activeMenu=='my')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => hotple.address && !((hotple.region == hotple.address.substring(0,2)) || hotple.region == hotple.address.charAt(0) + hotple.address.charAt(2)))}
				break;
			  case 'err_kakao':
				if(activeMenu=='my')
				  setSelectedOption((prev)=>({...prev, filter:'all'}))
				else
				  filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => !hotple.kakao_map_place_id)}
				break;
			  default:  //username인 경우
				filteredHotples = {hotples:filteredHotples.hotples.filter(hotple => (hotple.taggedBy == selectedOption.filter || (hotple.comment && hotple.comment.includes(selectedOption.filter))))}
			}
		  }
	
		  return filteredHotples;
	  };

	return (
		<div className={styles.frame}>
			<BrowserView className={styles.contents}>
				{account.hotpleId == null ? 
					<LoginHeader setAuthModalPage={setAuthModalPage} setTutorialModalPage={setTutorialModalPage}/> :
					(activeMenu == 'admin' && account.isAdmin ?
						<AdminHeader setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setSelectedOption={setSelectedOption} notices={notices} account={account} adminHotples={adminHotples} updateHotpleInfo={updateHotpleInfo} fcmToken={fcmToken} setModalProps={setModalProps}/> :
						<UserHeader setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} activeMenu={activeMenu} setActiveMenu={setActiveMenu} setSelectedOption={setSelectedOption} account={account} myHotples={myHotples} fcmToken={fcmToken} setModalProps={setModalProps}/>
					)
				}
				<div className={styles.divider} />
				<LocationBar mapHotples={mapHotples} mapLocation={mapLocation} setIsSearchMode={setIsSearchMode}/>
				<div className={styles.hotpleitems} id="hotpleitems-container">
					{((activeMenu=='my' && myHotples.hotples.length>0) || (activeMenu=='admin' && adminHotples.hotples.length>0)) &&
						<div className={styles.filterbuttons}>
							<div className={selectedOption.filter == 'all' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'all'}))}>
								<div className={styles.label}>전체</div>
							</div>
							<div className={selectedOption.filter == 'need_verify' ? styles.needverifybuttonSelected : styles.needverifybutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'need_verify'}))}>
								<img className={styles.iconupdate} alt="" src="images/update.svg" />
								<div className={styles.label}>검토 필요</div>
							</div>
							{activeMenu=='my' ?
								<div className={selectedOption.filter == 'my_pick' ? styles.mypickbuttonSelected : styles.mypickbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'my_pick'}))}>
									<img className={styles.iconstar} alt="" src="images/star_filled.svg" />
									<div className={styles.label}>내 PICK</div>
								</div>
								:
								<div className={selectedOption.filter == 'edit_request' ? styles.mypickbuttonSelected : styles.mypickbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'edit_request'}))}>
									<img className={styles.iconstar} alt="" src="images/star_filled.svg" />
									<div className={styles.label}>수정 요청</div>
								</div>
							}
							<div className={selectedOption.filter == 'has_period' ? styles.periodbuttonSelected : styles.periodbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'has_period'}))}>
								<img className={styles.iconupdate} alt="" src="images/notification.svg" />
								<div className={styles.label}>기간</div>
							</div>
							{activeMenu=='admin' &&
								<>
									<div className={selectedOption.filter == 'err_image' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_image'}))}>
										<div className={styles.label}>사진 {adminHotples.hotples.filter(hotple => !hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_info' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_info'}))}>
										<div className={styles.label}>정보 {adminHotples.hotples.filter(hotple => !hotple.name || !hotple.caption || !hotple.main_category || !hotple.sub_category1 || !hotple.sub_category2 || !hotple.tags || !hotple.place_name || !hotple.address || !hotple.region || !hotple.latitude || !hotple.longitude || !hotple.media_url).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_place' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_place'}))}>
										<div className={styles.label}>장소 {adminHotples.hotples.filter(hotple => hotple.address && !((hotple.region == hotple.address.substring(0,2)) || hotple.region == hotple.address.charAt(0) + hotple.address.charAt(2))).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_kakao' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_kakao'}))}>
										<div className={styles.label}>카카오맵 {adminHotples.hotples.filter(hotple => !hotple.kakao_map_place_id).length}</div>
									</div>
									<div className={styles.refreshButton} onClick={()=>refreshAdminHotple()}>
										<div className={styles.label}>↻</div>
									</div>
								</>
							}
							{[...new Set(myHotples.hotples.flatMap(hotple => {
								const taggedByUsernames = hotple.taggedBy ? [hotple.taggedBy] : [];
								const commentUsernames = hotple.comment ? (hotple.comment.match(/(@[\w\.]+)/g) || []).map(username => username.substring(1)) : [];

								return [...taggedByUsernames, ...commentUsernames];
							}).filter(username => username && username !== account.instagramUsername))].map(username => (
								<div
									className={selectedOption.filter == username ? styles.usernamebuttonSelected : styles.usernamebutton}
									onClick={() => setSelectedOption(prev => ({ ...prev, filter: username }))}
									key={username}
								>
									<div className={styles.label4}>@{username}</div>
								</div>
							))}
						</div>
					}
					{mapHotples.hotples && mapHotples.hotples.length > 0 ? (
						mapHotples.hotples.filter(hotple => activeMenu=='admin'? true : hotple.name)
							.map(hotple => (
							<div
								style={{ width: '100%' }}
								key={hotple.hotple_id}
								ref={el => (hotpleRefs.current[hotple.hotple_id] = el)}
							>
								<HotpleItem
									key={hotple.hotple_id}
									hotple={hotple}
									activeMenu={activeMenu}
									updateHotpleInfo={updateHotpleInfo}
									setSelectedHotple={setSelectedHotple}
									isSelected={selectedHotple && hotple.hotple_id === selectedHotple.hotple_id}
									hotThreshold={hotThreshold}
									devicePosition={devicePosition}
									setAnlysisPageHotple={setAnlysisPageHotple}
								/>
							</div>
							)
						)
					) : (
						<div className={styles.div9}>
							<img className={styles.markerstoryIcon} alt="" src="images/marker_position.svg" />
							<div className={styles.div10}>
								<p className={styles.p9}>{activeMenu=='search' ? '해당 조건의 핫플을 찾지 못했어요!' : (myHotples.hotples.length==0 ? '아직 내 핫플이 비어있어요!' : '내 핫플에선 해당 조건의 핫플을 찾지 못했어요.')}</p>
								<p className={styles.p9}>{activeMenu=='search' ? '검색 범위를 더 넓혀볼까요?' : (myHotples.hotples.length==0? '\'핫플찾기\'에서 마음에 드는 핫플을 찾아볼까요?' : '\'핫플찾기\' 탭에서 검색해볼까요?')}</p>
							</div>
						</div>
					)}
				</div>
			</BrowserView>

			<MobileView className={styles.contents1}>
				{selectedHotple==null && 
					<>
						{account.hotpleId == null ? 
							<LoginHeader setAuthModalPage={setAuthModalPage} setTutorialModalPage={setTutorialModalPage}/> :
							(activeMenu == 'admin' && account.isAdmin ?
								<AdminHeader setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setSelectedOption={setSelectedOption} notices={notices} account={account} adminHotples={adminHotples} updateHotpleInfo={updateHotpleInfo} fcmToken={fcmToken} setModalProps={setModalProps}/>
								:
								activeMenu == 'my' &&
									<UserHeader setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} activeMenu={activeMenu} setActiveMenu={setActiveMenu} setSelectedOption={setSelectedOption} account={account} myHotples={myHotples} fcmToken={fcmToken} setModalProps={setModalProps}/>
								
							)
						}
						<div className={styles.divider} />
					</>
				}
				<div className={styles.hotpleitems1} id="hotpleitems-container" ref={mobileContainerRef}>
					{((activeMenu=='my' && myHotples.hotples.length>0) || (activeMenu=='admin' && adminHotples.hotples.length>0)) && selectedHotple == null &&
						<div className={styles.filterbuttons}>
							<div className={selectedOption.filter == 'all' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'all', sub_category: 'all'}))}>
								<div className={styles.label}>전체</div>
							</div>
							{[...new Set(myHotples.hotples.flatMap(hotple => {
								const taggedByUsernames = hotple.taggedBy ? [hotple.taggedBy] : [];
								const commentUsernames = hotple.comment ? (hotple.comment.match(/(@[\w\.]+)/g) || []).map(username => username.substring(1)) : [];

								return [...taggedByUsernames, ...commentUsernames];
							}).filter(username => username && username !== account.instagramUsername))].map(username => (
								<div
									className={selectedOption.filter == username ? styles.usernamebuttonSelected : styles.usernamebutton}
									onClick={() => setSelectedOption(prev => ({ ...prev, filter: username, sub_category: 'all'}))}
									key={username}
								>
									<div className={styles.label4}>@{username}</div>
								</div>
							))}
							<div className={selectedOption.filter == 'need_verify' ? styles.needverifybuttonSelected : styles.needverifybutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'need_verify', sub_category: 'all'}))}>
								<img className={styles.iconupdate} alt="" src="images/update.svg" />
								<div className={styles.label}>검토 필요</div>
							</div>
							{activeMenu=='my' ?
								<div className={selectedOption.filter == 'my_pick' ? styles.mypickbuttonSelected : styles.mypickbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'my_pick', sub_category: 'all'}))}>
									<img className={styles.iconstar} alt="" src="images/star_filled.svg" />
									<div className={styles.label}>내 PICK</div>
								</div>
								:
								<div className={selectedOption.filter == 'edit_request' ? styles.mypickbuttonSelected : styles.mypickbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'edit_request', sub_category: 'all'}))}>
									<img className={styles.iconstar} alt="" src="images/star_filled.svg" />
									<div className={styles.label}>수정 요청</div>
								</div>
							}
							<div className={selectedOption.filter == 'has_period' ? styles.periodbuttonSelected : styles.periodbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'has_period', sub_category: 'all'}))}>
								<img className={styles.iconupdate} alt="" src="images/notification.svg" />
								<div className={styles.label}>기간</div>
							</div>
							{activeMenu=='admin' &&
								<>
									<div className={selectedOption.filter == 'err_image' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_image', sub_category: 'all'}))}>
										<div className={styles.label}>사진 {adminHotples.hotples.filter(hotple => !hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_info' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_info', sub_category: 'all'}))}>
										<div className={styles.label}>정보 {adminHotples.hotples.filter(hotple => !hotple.name || !hotple.caption || !hotple.main_category || !hotple.sub_category1 || !hotple.sub_category2 || !hotple.tags || !hotple.place_name || !hotple.address || !hotple.region || !hotple.latitude || !hotple.longitude).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_place' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_place', sub_category: 'all'}))}>
										<div className={styles.label}>장소 {adminHotples.hotples.filter(hotple => hotple.address && !((hotple.region == hotple.address.substring(0,2)) || hotple.region == hotple.address.charAt(0) + hotple.address.charAt(2))).length}</div>
									</div>
									<div className={selectedOption.filter == 'err_kakao' ? styles.allbuttonSelected : styles.allbutton} onClick={()=>setSelectedOption((prev)=>({...prev, filter:'err_kakao', sub_category: 'all'}))}>
										<div className={styles.label}>카카오맵 {adminHotples.hotples.filter(hotple => !hotple.kakao_map_place_id).length}</div>
									</div>
									<div className={styles.refreshButton} onClick={()=>refreshAdminHotple()}>
										<div className={styles.label}>↻</div>
									</div>
								</>
							}
						</div>
					}
					{selectedHotple == null && (activeMenu=='my' || activeMenu=='admin') &&
						<div className={styles.tagButtonFrame}>
							<div className={selectedOption.sub_category == 'all' ? styles.buttonActive : styles.button} key='all' onClick={()=>toggleSubCategoryOption('all')}>전체</div>
							{activeMenu=='my' && [...new Set(getFilteredMapHotples(myHotples).hotples.map(hotple => hotple.sub_category1))].map((category, index) => (
								<div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
							))}
							{activeMenu=='admin' && [...new Set(getFilteredMapHotples(adminHotples).hotples.map(hotple => hotple.sub_category1))].map((category, index) => (
								<div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
							))}
						</div>
					}
					{selectedHotple==null ?
							totalPages > 0 ?
							<>
							  {currentHotplePage.map((hotple, index) => (
								<div
								  className={styles.hotpleitem}
								  key={index}
								  ref={el => mobileHotpleRefs.current[hotple.hotple_id] = el}
								>
								  <HotpleItem
									hotple={hotple}
									activeMenu={activeMenu}
									updateHotpleInfo={updateHotpleInfo}
									setSelectedHotple={setSelectedHotple}
									isSelected={false}
									hotThreshold={hotThreshold}
									devicePosition={devicePosition}
									setAnlysisPageHotple={setAnlysisPageHotple}
								  />
								</div>
							  ))}
							  <div style={{height:"58px"}}/>
							</>
						:
							(
								<div className={styles.div9}>
									<img className={styles.markerstoryIcon} alt="" src="images/marker_position.svg" />
									<div className={styles.div10}>
										<p className={styles.p9}>{activeMenu=='search' ? '해당 조건의 핫플을 찾지 못했어요!' : (myHotples.hotples.length==0 ? '아직 내 핫플이 비어있어요!' : '내 핫플에선 해당 조건의 핫플을 찾지 못했어요.')}</p>
										<p className={styles.p9}>{activeMenu=='search' ? '검색 범위를 더 넓혀볼까요?' : (myHotples.hotples.length==0? '\'핫플찾기\'에서 마음에 드는 핫플을 찾아볼까요?' : '\'핫플찾기\' 탭에서 검색해볼까요?')}</p>
									</div>
								</div>
							)
					:
						<HotpleItem key={selectedHotple.hotple_id} hotple={mapHotples?.hotples?.find(hotple => hotple.hotple_id == selectedHotple?.hotple_id)} activeMenu={activeMenu} updateHotpleInfo={updateHotpleInfo} setSelectedHotple={setSelectedHotple} isSelected={true} hotThreshold={hotThreshold} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
					}
					{selectedHotple === null && totalPages > 1 && (
						<div className={styles.pagination}>
							<div className={styles.pageButton} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 0))} disabled={currentPage === 0}>
								◀
							</div>
							<div className={styles.pageIndex}>
								{currentPage + 1} / {totalPages}
							</div>
							<div className={styles.pageButton} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages - 1))} disabled={currentPage >= totalPages - 1}>
								▶
							</div>
						</div>
					)}
					{selectedHotple === null && 
						<img className={styles.topButton} onClick={whenTopButtonClicked}  alt="" src="images/chevron_bottom.svg" />
					}
				</div>
			</MobileView>
		</div>
		);
};

export default HotpleContents;
